import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatabasesQueryByIdsGql: DocumentNode = gql`
query DatabasesQueryByIds($first: Int!, $offset: Int!, $databaseIds: [ID]!) {
  databasesConnection(
    first: $first,
    offset: $offset,
    filter: { idWithin: $databaseIds }
  ) {
    totalCount
    nodes {
      id
      name
      controlledPermissionsEnabled: isControlledPermissionsEnabled
    }
  }
}
`;
